import { Route, Switch } from 'react-router-dom'

import { ChooseInArea } from '@main/containers/colleges/ChooseInArea'
import CollegeProfile from '@main/containers/colleges/CollegeProfile'
import { CollegeComparison } from '@main/containers/colleges/CollegeComparison'
import CostBenefitInstructions from '@main/containers/colleges/CostBenefitInstructions'
import FinancialAid from '@main/containers/financialaid/FinancialAid'
import CollegePreferences from '@main/containers/colleges/CollegePreferences'
import CollegeListing from '@main/containers/colleges/CollegeListing'

import { OccupationDetail } from './detail'

const Colleges = () => {
  const routes = [
    {
      path: '/colleges/location',
      exact: true,
      render(props) {
        return <ChooseInArea {...props} />
      }
    },
    {
      path: '/colleges/p/:collegeId',
      exact: true,
      render(props) {
        return <CollegeProfile {...props} />
      }
    },
    {
      path: '/colleges/comparison',
      exact: true,
      render(props) {
        return <CollegeComparison {...props} />
      }
    },
    {
      path: '/colleges/costbenefit',
      exact: true,
      render(props) {
        return <CostBenefitInstructions {...props} />
      }
    },
    {
      path: '/colleges/financialaid',
      exact: true,
      render(props) {
        return <FinancialAid {...props} />
      }
    },
    {
      path: '/colleges/preferences',
      exact: true,
      render(props) {
        return <CollegePreferences {...props} />
      }
    },
    {
      path: '/colleges/list',
      exact: true,
      render(props) {
        return <CollegeListing {...props} />
      }
    },
    {
      path: '/colleges/profile/:institutionId',
      exact: true,
      render(props) {
        return <OccupationDetail {...props} />
      }
    }
  ]

  return (
    <div>
      <Switch>
        {routes.map((route, idx) => (
          <Route
            key={idx}
            {...route}
            render={props => {
              return route.render({ ...props })
            }}
          />
        ))}
      </Switch>
    </div>
  )
}

export { Colleges }
